import type { RootState } from '../../../Redux/store'

export const tokenSelector = (state: RootState) => state.authorization.token
export const isAuthorizedSelector = (state: RootState) =>
  state.authorization.authorized
export const authErrorSelector = (state: RootState) =>
  state.authorization.authorizationError
